const FREE = [
	"energy",
	"rust",
	"forest",
	"waves",
	"nature",
	"nostalgia"
] as const;

const REWARDS = [
	"ember",
	"neon",
	"arctic",
	"meadow",
	"terra",
	"midnight",
	"dockside",
	"beacon",
	"atlas",
	"cyber",
	"asphalt",
	"parade",
	"rosewater",
	"dayglow",
	"campfire",
	"arcade",
	"harvest",
	"confetti",
	"tides",
	"bloom",
	"paprika",
	"gemstone",
	"crown",
	"oasis",
	"sprout",
	"playful",
	"sundown",
	"seaside",
	"heirloom",
	"colorwheel",
	"mixtape",
	"tropical",
	"dusk",
	"tron",
	"synthwave",
	"friends"
] as const;

const PREMIUM = [
	"candy",
	"pastel",
	"glow",
	"murky",
	"fire",
	"vacation",
	"bright",
	"mono",
	"electric",
	"glacier",
	"marshmallow",
	"chrome",
	"ceramic",
	"wavelength",
	"ultraviolet",
	"mint",
	"supernova",
	"tailored"
] as const;

export const MINDMAP_PALETTE_KINDS = [...FREE, ...REWARDS, ...PREMIUM] as const;

export type MindmapPaletteKind = (typeof MINDMAP_PALETTE_KINDS)[number];

export const FREE_MINDMAP_PALETTE_KINDS: readonly MindmapPaletteKind[] = FREE;
export const REWARD_MINDMAP_PALETTE_KINDS: readonly MindmapPaletteKind[] = REWARDS;
export const PREMIUM_MINDMAP_PALETTE_KINDS: readonly MindmapPaletteKind[] = PREMIUM;

export const DEFAULT_MINDMAP_PALETTE_KIND: MindmapPaletteKind = "energy";
